import { dqgj } from '@/axios'
import { Message } from 'element-ui'
let that;
export default{
	data(){
		return{
			imageUrl:"",
			isUploaded:"上传封面图",
			type:"图文",
			formData:{
				id:"",
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				type:3, //业务发展
				title:"",
				sz_img:"",
				source:"",
				class_id:"",
				url:"",
				content:"",
				pub_time:""
			},
			rules:{
				// 检测标题是否为空
				title: [
					{ required: true, message: '请输入标题', trigger: 'blur' }
				],
				// 检测文本是否为空
				content: [
					{ required: true, message: '请输入内容', trigger: 'blur' }
				],
				// 检测链接是否为空
				url: [
					{ required: true, message: '请输入链接', trigger: 'blur' }
				],
			}
		}
	},
	methods:{
		// 获取数据
		getdata(){
			dqgj.dqgjUpdateGet({id:that.$route.query.id}).then(res => {
				if(res.code == 200){
					for(var key in res.data){
						for(var keys in that.formData){
							if(key == keys){
								that.formData[keys] = res.data[key]
							}
						}
					}
					that.type = res.data.content?'图文':'链接';
					that.imageUrl = res.data.sz_img?res.data.sz_img:''
				}
			})
		},
		//提交
		submit(){
			that.$refs.formData.validate((valid) => {
				if (valid) {
					if(that.$route.query.type == 'edit'){
						dqgj.dqgjUpdate(that.formData).then(res => {
							if(res.code == 200){
								Message({
									type:"success",
									message:"成功"
								})
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}else{
						dqgj.dqgjAdd(that.formData).then(res => {
							if(res.code == 200){
								Message({
									type:"success",
									message:"成功"
								})
								that.$router.go(-1);
							}else{
								Message({
									type:"error",
									message:res.msg
								})
							}
						})
					}
				} else {
					return false;
				}
			});
		},
		// 类型切换时
		changeType(value){
			if(value == "图文"){
				that.formData.url = '';
			}else{
				that.formData.content = '';
			}
		},
		// 上传封面图成功
		success(res, file) {
			if(res.code == 200){
				that.imageUrl = URL.createObjectURL(file.raw);
				that.isUploaded = "重新上传"
				that.formData.sz_img = res.data.src
			}else{
				Message({
					type:"error",
					message:"上传失败，请检查文件或网络连接"
				})
			}
		}
	},
	mounted() {
		if(that.$route.query.type == 'edit'){
			that.getdata();
		}
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}